<template>
  <el-dialog
    title="维修验收单预览"
    :visible.sync="dialogVisible"
    width="90%"
   
    :before-close="handleClose"
    class="preview-acceptance-dialog"
  >
    <div v-loading="loading" class="preview-content">
      <div v-if="acceptanceDetail" class="forms-container">
        <!-- 验收单表格 -->
        <div id="acceptance-form" class="acceptance-form page-break">
        <!-- 表格 -->
        <table class="acceptance-table" border="1" cellspacing="0" cellpadding="0">
          <!-- 标题行 -->
          <tr>
            <td colspan="4" class="title-cell">
              资中县兴资物业管理有限责任公司维修验收单
            </td>
          </tr>
          
          <!-- 第一行：验收名称、验收时间 -->
          <tr>
            <td class="label-cell">验收名称</td>
            <td class="value-cell">{{ getAcceptanceName() }}</td>
            <td class="label-cell">验收时间</td>
            <td class="value-cell">{{ getCurrentDate() }}</td>
          </tr>
          
          <!-- 第二行：维修实施单位、验收地点 -->
          <tr>
            <td class="label-cell">维修实施单位</td>
            <td class="value-cell">{{ getSupplierName() }}</td>
            <td class="label-cell">验收地点</td>
            <td class="value-cell">{{ getLocationText() }}</td>
          </tr>
          
          <!-- 第三行：验收组织部门 -->
          <tr>
            <td class="label-cell">验收组织部门</td>
            <td colspan="3" class="value-cell">{{ communityName() }}</td>
          </tr>
          
          <!-- 第四行：验收内容 -->
          <tr>
            <td class="label-cell">验收内容</td>
            <td colspan="3" class="value-cell content-text">
              {{ acceptanceDetail.problemDesc || acceptanceDetail.content || '-' }}
            </td>
          </tr>
          
          <!-- 第五行：验收结果 -->
          <tr>
            <td class="label-cell">验收结果</td>
            <td colspan="3" class="value-cell">已正常使用</td>
          </tr>
          
          <!-- 第六行：结算金额 -->
          <tr>
            <td class="label-cell">结算金额</td>
            <td colspan="3" class="value-cell">{{ getSettlementAmount() }}</td>
          </tr>
          
          <!-- 第七行：施工单位负责人签字  v-if="getSignatureByRole('施工单位')"-->
          <tr >
            <td class="label-cell">施工单位负责人签字</td>
            <td colspan="3" class="signature-cell">
              <!-- <div class="signature-wrapper">
                <img :src="getSignatureByRole('施工单位')" class="signature-image"
                  @error="handleImageError" />
              </div> -->
            </td>
          </tr>
          
          <!-- 第八行：验收人员签字 -->
          <tr v-if="getSignaturesByRole('验收').length > 0">
            <td class="label-cell">验收人员签字</td>
            <td colspan="3" class="signature-cell">
              <div class="signature-wrapper">
                <img v-for="(sig, idx) in getSignaturesByRole('验收')" :key="idx"
                  :src="sig.img" class="signature-image"
                  @error="handleImageError" />
              </div>
            </td>
          </tr>
          
          <!-- 第九行：施工维修及验收图片 
          <tr>
            <td colspan="4" class="section-title-cell">施工维修及验收图片</td>
          </tr>-->
          
          <!-- 第十行：维修图片标签
          <tr>
            <td colspan="4" class="images-label-cell">施工维修及验收图片：</td>
          </tr> -->
          
          <!-- 第十一行：图片展示区 
          <tr>
            <td colspan="4" class="images-section-cell-all">
              <div v-if="getAllImages().length > 0" class="image-grid-all">
                <div
                  v-for="(img, index) in getAllImages()"
                  :key="'all-' + index"
                  class="image-item-all"
                >
                  <img :src="img" class="acceptance-image" @error="handleImageError" />
                </div>
              </div>
            </td>
          </tr>-->
          
          <!-- 第十二行：物业管理处 
            <td colspan="4" class="footer-cell">{{ getCommunityName() }}</td>
          </tr>
          <tr>-->
          
          <!-- 第十三行：日期 
          <tr>
            <td colspan="4" class="footer-cell">{{ getCurrentDate() }}</td>
          </tr>-->
        </table>
      </div>

      <!-- 维修过程监督表格 -->
      <div id="supervision-form" class="supervision-form">
        <table class="supervision-table" border="1" cellspacing="0" cellpadding="0">
          <!-- 标题行 -->
          <tr>
            <td class="title-cell">维修过程监督</td>
          </tr>
          
          <!-- 维修前照片 -->
          <tr>
            <td class="section-label-cell">维修前照片</td>
          </tr>
          <tr>
            <td class="images-section-cell-large">
              <div class="images-wrapper">
                <div v-if="getImageList(acceptanceDetail.problemImgs).length > 0" class="image-grid-supervision">
                  <div
                    v-for="(img, index) in getImageList(acceptanceDetail.problemImgs)"
                    :key="'before-' + index"
                    :class="['image-item-supervision', getImageList(acceptanceDetail.problemImgs).length <= 3 ? 'large-image' : '']"
                  >
                    <img :src="img" :class="['supervision-image', getImageList(acceptanceDetail.problemImgs).length <= 3 ? 'large-image' : '']" @error="handleImageError" />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          
          <!-- 维修中照片 -->
          <tr>
            <td class="section-label-cell">维修中照片</td>
          </tr>
          <tr>
            <td class="images-section-cell-large">
              <div class="images-wrapper">
                <div v-if="getProcessImageList().length > 0" class="image-grid-supervision">
                  <div
                    v-for="(img, index) in getProcessImageList()"
                    :key="'process-' + index"
                    :class="['image-item-supervision', getProcessImageList().length <= 3 ? 'large-image' : '']"
                  >
                    <img :src="img" :class="['supervision-image', getProcessImageList().length <= 3 ? 'large-image' : '']" @error="handleImageError" />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          
          <!-- 维修后照片 -->
          <tr>
            <td class="section-label-cell">维修后照片</td>
          </tr>
          <tr>
            <td class="images-section-cell-large">
              <div class="images-wrapper">
                <div v-if="getAfterImageList().length > 0" class="image-grid-supervision">
                  <div
                    v-for="(img, index) in getAfterImageList()"
                    :key="'after-' + index"
                    :class="['image-item-supervision', getAfterImageList().length <= 3 ? 'large-image' : '']"
                  >
                    <img :src="img" :class="['supervision-image', getAfterImageList().length <= 3 ? 'large-image' : '']" @error="handleImageError" />
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
      <el-button type="primary" @click="handleExportAcceptancePDF">导出验收单PDF</el-button>
      <el-button type="success" @click="handleExportSupervisionPDF">导出维修监督PDF</el-button>
    </span>
  </el-dialog>
</template>

<script>
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
	import {
		getCommunityId,
		getStoreName
	} from '@/api/community/communityApi'
export default {
  name: 'PreviewAcceptanceForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    acceptanceDetail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      parsedSignatureList: []
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    acceptanceDetail: {
      handler(val) {
        if (val) {
          this.parseAcceptanceDetailData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    
    // 鑾峰彇验收名称 - 鏍规嵁orderType鍒ゆ柇
    getAcceptanceName() {
      if (!this.acceptanceDetail) return 'XX维修'
      
      const orderType = this.acceptanceDetail.orderType
      if (orderType === 0 || orderType === '0') {
        return '室内维修'
      } else if (orderType === 1 || orderType === '1') {
        return '公区维修'
      }
      return 'XX维修'
    },
    
    // 获取当前日期 - 格式：2026年X月X日
    getCurrentDate() {
      // 优先使用acceptTime字段
      if (this.acceptanceDetail && this.acceptanceDetail.acceptTime) {
        return this.formatDateToChineseStyle(this.acceptanceDetail.acceptTime)
      }
      
      // 如果没有acceptTime，使用当前时间
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const day = now.getDate()
      return `${year}年${month}月${day}日`
    },

    //小区名称
    communityName() {
      return this.acceptanceDetail.communityName+"管理处"|| getStoreName()
      //return getStoreName()||'-'
    },
    
    // 格式化日期为中文样式：2026年X月X日
    formatDateToChineseStyle(dateString) {
      if (!dateString) return ''
      
      try {
        const date = new Date(dateString)
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        return `${year}年${month}月${day}日`
      } catch (error) {
        console.log('日期格式化失败', error)
        return ''
      }
    },
    
    // 获取供应商名称
    getSupplierName() {
      if (!this.acceptanceDetail) return '**公司'
      console.log(this.acceptanceDetail.supplierInfo)
      // 尝试从supplierInfo解析
      if (this.acceptanceDetail.supplierInfo) {
        try {
          let supplierInfo = this.acceptanceDetail.supplierInfo
          if (typeof supplierInfo === 'string') {
            supplierInfo = JSON.parse(supplierInfo)
          }
          
          // 如果有suppliers数组，获取contactName
          if (supplierInfo.suppliers && Array.isArray(supplierInfo.suppliers) && supplierInfo.suppliers.length > 0) {
            const contactNames = supplierInfo.suppliers.map(item => item.name || '').filter(name => name)
            if (contactNames.length > 0) {
              return contactNames.join('，')
            }
          }

          if (Array.isArray(supplierInfo) && supplierInfo.length > 0) {
            const names = supplierInfo.map(item => item.name || '').filter(name => name)
            if (names.length > 0) {
              return names.join('，')
            }
          } else if (supplierInfo && supplierInfo.name) {
            return supplierInfo.name
          }
        } catch (e) {
          console.warn('解析供应商信息失败', e)
        }
      }
      
      // 如果没有供应商信息，使用小区名称 + 公司
      const communityName = this.acceptanceDetail.communityName || 
                           this.acceptanceDetail.community || 
                           this.acceptanceDetail.projectName ||
                           '**'
    	const storeName = getStoreName();
				return storeName.includes('公司') ? storeName : storeName + '公司自修';
    },
    
    // 获取维修地点
    getLocationText() {
      if (!this.acceptanceDetail) return '**'
      
      // 如果是公区报修(orderType === 1)，使用 addressDetail
      if (this.acceptanceDetail.orderType === 1 || this.acceptanceDetail.orderType === '1') {
        return this.acceptanceDetail.communityName+ this.acceptanceDetail.addressDetail || '**'
      } 
      // 如果是室内报修(orderType === 0)，使用 roomName
      else if (this.acceptanceDetail.orderType === 0 || this.acceptanceDetail.orderType === '0') {
        return this.acceptanceDetail.communityName+ this.acceptanceDetail.roomName || '**'
      }
      
      // 默认情况
      return this.acceptanceDetail.communityName+(this.acceptanceDetail.addressDetail || this.acceptanceDetail.roomName || '**')
    },
    
    // 鑾峰彇结算金额
    getSettlementAmount() {
      if (!this.acceptanceDetail) return '**元'
      
      // 尝试从auditControl获取控价金额
      if (this.acceptanceDetail.auditControl) {
        try {
          let auditControl = this.acceptanceDetail.auditControl
          if (typeof auditControl === 'string') {
            auditControl = JSON.parse(auditControl)
          }
          
          if (auditControl && auditControl.controlNum) {
            return `${auditControl.controlNum}元`
          }
        } catch (e) {
          console.warn('解析审核控价信息失败:', e)
        }
      }
      
      // 尝试从其他字段获取金额
      if (this.acceptanceDetail.repairMaterialFee) {
        return `${this.acceptanceDetail.repairMaterialFee}元`
      }
      
      return '**元'
    },
    
    // 获取小区名称 + 物业管理处
    getCommunityName() {
      if (!this.acceptanceDetail) return '**物业管理处'
      
      // 尝试从多个可能的字段获取小区名称
      const communityName = this.acceptanceDetail.communityName || 
                           this.acceptanceDetail.community || 
                           this.acceptanceDetail.projectName ||
                           '**'
      
      return `${communityName}物业管理处`
    },
    
    getImageList(imgsString) {
      if (!imgsString || typeof imgsString !== 'string') {
        return []
      }
      return imgsString.split(',').filter(url => url.trim() !== '')
    },
	
    
    // 获取维修过程图片
    getProcessImageList() {
      if (!this.acceptanceDetail || !this.acceptanceDetail.repairProcessImgs) return []
      
      try {
        const data = typeof this.acceptanceDetail.repairProcessImgs === 'string' 
          ? JSON.parse(this.acceptanceDetail.repairProcessImgs) 
          : this.acceptanceDetail.repairProcessImgs
        
        if (data && data.images) {
          if (typeof data.images === 'string') {
            return data.images.split(',').filter(img => img.trim())
          }
          if (Array.isArray(data.images)) {
            return data.images.filter(img => img && img.trim())
          }
        }
		
        return []
      } catch (err) {
        console.log('解析维修图片失败:', err)
        return []
      }
    },
    
    // 获取维修后图片
    getAfterImageList() {
      if (!this.acceptanceDetail || !this.acceptanceDetail.repairAfterImgs) return []
      
      try {
        let data
        if (typeof this.acceptanceDetail.repairAfterImgs === 'string') {
          data = JSON.parse(this.acceptanceDetail.repairAfterImgs)
        } else {
          data = this.acceptanceDetail.repairAfterImgs
        }
        
        if (data && data.images) {
          if (typeof data.images === 'string') {
            return data.images.split(',').filter(img => img.trim())
          }
          if (Array.isArray(data.images)) {
            return data.images.filter(img => img && img.trim())
          }
        }
        return []
      } catch (err) {
        console.log('解析验收图片失败:', err)
        return []
      }
    },
    
    // 合并所有图片（维修前、维修中、维修后）
    getAllImages() {
      const beforeImages = this.getImageList(this.acceptanceDetail.problemImgs)
      const processImages = this.getProcessImageList()
      const afterImages = this.getAfterImageList()
      return [...beforeImages, ...processImages, ...afterImages]
    },

    // 解析验收详情数据
    parseAcceptanceDetailData() {
      if (!this.acceptanceDetail) return

      // 解析签名列表
      if (this.acceptanceDetail.signPics) {
        this.parsedSignatureList = this.parseSignatureList(this.acceptanceDetail.signPics)
      } else {
        this.parsedSignatureList = []
      }
    },

    // 解析签名列表
    parseSignatureList(signPicsData) {
      if (!signPicsData) return []
      try {
        let dataArray = []
        if (typeof signPicsData === 'string') {
          let cleanedData = signPicsData
            .replace(/,(\s*[}\]])/g, '$1')
            .replace(/,{2,}/g, ',')
            .replace(/\[,/g, '[')
            .replace(/,\]/g, ']')

          try {
            signPicsData = JSON.parse(cleanedData)
          } catch (parseErr) {
            console.warn('签名数据解析失败:', parseErr)
            return []
          }
        }
        if (Array.isArray(signPicsData)) {
          dataArray = signPicsData
        } else if (typeof signPicsData === 'object' && signPicsData !== null) {
          dataArray = [signPicsData]
        } else {
          return []
        }
        const result = []
        for (let item of dataArray) {
          if (typeof item === 'string') {
            try {
              let cleanedItem = item.replace(/,(\s*[}\]])/g, '$1')
              const parsed = JSON.parse(cleanedItem)
              if (parsed && typeof parsed === 'object') {
                result.push(parsed)
              }
            } catch (e) {
              console.warn('解析单条签名信息失败，已跳过:', item, e)
            }
          } else if (typeof item === 'object' && item !== null) {
            result.push(item)
          }
        }
        return result
      } catch (err) {
        console.warn('签名列表解析异常:', err)
        return []
      }
    },

    // 从signatureList提取指定角色的签名（使用包含匹配）
    getSignatureByRole(roleName) {
      if (!this.parsedSignatureList || this.parsedSignatureList.length === 0) {
        return ''
      }
      if(roleName=='施工单位') {
        const signature = this.parsedSignatureList.find(item => {
            if (!item.constructionRoleName) return false
            return item.constructionRoleName.includes(roleName) || roleName.includes(item.constructionRoleName)
          })
         return signature ? signature.constructionImg : ''
      }else{
      const signature = this.parsedSignatureList.find(item => {
            if (!item.roleName) return false
            return item.roleName.includes(roleName) || roleName.includes(item.roleName)
          })
         return signature ? signature.img : ''
      }
   
    },

    // 从signatureList提取指定角色的所有签名（返回数组）
    getSignaturesByRole(roleName) {
      if (!this.parsedSignatureList || this.parsedSignatureList.length === 0) {
        return []
      }
      var data =  this.parsedSignatureList.filter(item => {
        if (!item.roleName) return false
        return item.roleName.includes(roleName) || roleName.includes(item.roleName)
      })
        return data;
    },

    handleImageError(e) {
      e.target.style.display = 'none'
    },
    
    // 导出验收单PDF
    async handleExportAcceptancePDF() {
      await this.exportPDF('acceptance-form', '维修验收单')
    },
    
    // 导出维修监督PDF
    async handleExportSupervisionPDF() {
      await this.exportPDF('supervision-form', '维修过程监督')
    },
    
    async exportPDF(elementId, fileName) {
      if (!this.acceptanceDetail) {
        this.$message.warning('没有可导出的数据')
        return
      }
      
      try {
        await this.$confirm(`确定要导出${fileName}PDF吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        })
      } catch {
        return
      }
      
      const loadingInstance = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      try {
        const element = document.getElementById(elementId)
        if (!element) {
          throw new Error('未找到表格元素')
        }
        
        // A4纸张尺寸：210mm x 297mm，转换为像素（按2倍缩放）
        const pageWidth = 210 // mm
        const pageHeight = 297 // mm
        const scale = 2
        
        // 计算每页像素高度（考虑边距）
        const availableHeight = (pageHeight - 16) * scale // 减去边距后转为像素
        
        // 使用html2canvas生成完整内容
        const canvas = await html2canvas(element, {
          scale: scale,
          useCORS: true,
          allowTaint: true,
          logging: false,
          backgroundColor: '#ffffff',
          windowHeight: element.scrollHeight
        })
        
        const imgWidth = pageWidth
        const totalImgHeight = (canvas.height * imgWidth) / canvas.width
        
        // 计算需要多少页
        const numPages = Math.ceil(totalImgHeight / availableHeight)
        
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        })
        
        // 如果只有一页，直接添加
        if (numPages <= 1) {
          const imgData = canvas.toDataURL('image/jpeg', 1.0)
          pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, totalImgHeight)
        } else {
          // 多页分页处理
          const pageCanvas = document.createElement('canvas')
          const pageCtx = pageCanvas.getContext('2d')
          
          for (let i = 0; i < numPages; i++) {
            if (i > 0) {
              pdf.addPage()
            }
            
            const startY = i * availableHeight
            const endY = Math.min((i + 1) * availableHeight, canvas.height)
            const sliceHeight = endY - startY
            
            // 设置页面canvas尺寸
            pageCanvas.width = canvas.width
            pageCanvas.height = sliceHeight
            
            // 清除并绘制内容
            pageCtx.fillStyle = '#ffffff'
            pageCtx.fillRect(0, 0, pageCanvas.width, pageCanvas.height)
            pageCtx.drawImage(
              canvas,
              0, startY,
              canvas.width, sliceHeight,
              0, 0,
              canvas.width, sliceHeight
            )
            
            // 计算该页在PDF中的高度
            const pageImgHeight = (sliceHeight * imgWidth) / canvas.width
            
            const imgData = pageCanvas.toDataURL('image/jpeg', 1.0)
            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, pageImgHeight)
          }
        }
        
        const pdfFileName = `${this.acceptanceDetail.acceptanceNo || this.acceptanceDetail.acceptanceId || 'acceptance'}_${fileName}.pdf`
        
        pdf.save(pdfFileName)
        
        this.$message.success('PDF生成成功')
      } catch (error) {
        console.log('PDF generation error:', error)
        this.$message.error('PDF生成失败：' + error.message)
      } finally {
        loadingInstance.close()
      }
    },
    
    async handleExportPDF() {
      // 保留旧方法以兼容
      await this.handleExportAcceptancePDF()
    }
  }
}
</script>

<style scoped>
.preview-acceptance-dialog >>> .el-dialog {
  max-height: none;
  display: flex;
  flex-direction: column;
}

.preview-acceptance-dialog >>> .el-dialog__body {
  flex: 1;
  overflow: visible;
  padding: 20px;
  background-color: #f0f0f0;
}

.preview-content {
  display: flex;
  justify-content: center;
  overflow: visible;
}

.forms-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

/* A4纸张尺寸：210mm x 297mm */
.acceptance-form,
.supervision-form {
  background: white;
  width: 210mm;
  min-height: 297mm;
  padding: 8mm;
  margin: 0 auto;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  box-sizing: border-box;
}

.acceptance-table,
.supervision-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #999;
  table-layout: fixed;
}

.acceptance-table td {
  border: 1px solid #999;
  padding: 10px 8px;
  font-size: 13px;
  vertical-align: middle;
  word-wrap: break-word;
  line-height: 1.5;
  color: #000;
}

/* 标题单元格 */
.title-cell {
  text-align: center !important;
  font-size: 24px !important;
  font-weight: bold !important;
  padding: 15px 12px !important;
  line-height: 1.5 !important;
  color: #000 !important;
  background-color: #fff !important;
}

.label-cell {
  font-weight: normal;
  text-align: center;
  width: 25%;
  color: #000;
  background-color: #fff;
  padding: 10px 5px !important;
}

.value-cell {
  text-align: center;
  color: #000;
  padding: 10px 8px !important;
  line-height: 1.5;
  width: 25%;
}

/* 验收内容鏂囧瓧 - 宸﹀榻?*/
.content-text {
  text-align: left !important;
  padding-left: 10px !important;
}

/* 签名单元格 */
.signature-cell {
  height: 50px;
  padding: 10px !important;
  text-align: left;
}

/* 章节标题单元格 */
.section-title-cell {
  text-align: center;
  font-weight: normal;
  padding: 10px !important;
  background-color: #fff;
  color: #000;
  font-size: 13px;
}

/* 图片标签单元格 */
.images-label-cell {
  text-align: left;
  font-weight: normal;
  padding: 5px 10px !important;
  color: #000;
  font-size: 13px;
}

/* 图片区域单元格 */
.images-section-cell {
  padding: 8px 10px !important;
  vertical-align: top;
  height: 150px;
}

/* 合并图片区域单元格 */
.images-section-cell-all {
  padding: 10px !important;
  vertical-align: top;
  min-height: 200px;
}

/* 验收单图片网格 - 每行3张 */
.image-grid-acceptance {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 100%;
  height: 100%;
}

/* 合并图片网格 */
.image-grid-all {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  width: 100%;
}

.image-item-acceptance {
  width: 100%;
  height:200px;
  overflow: hidden;
  border: none;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-item-all {
  width: 100%;
  height: 150px;
  overflow: hidden;
  border: 1px solid #ddd;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.acceptance-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 底部单元格 */
.footer-cell {
  text-align: center;
  padding: 10px !important;
  font-weight: normal;
  color: #000;
  font-size: 13px;
}

/* 维修监督表格样式 */
.supervision-table td {
  border: 1px solid #999;
  padding: 10px 8px;
  font-size: 13px;
  vertical-align: middle;
  word-wrap: break-word;
  line-height: 1.5;
  color: #000;
}

.section-label-cell {
  text-align: center;
  font-weight: normal;
  padding: 10px !important;
  background-color: #fff;
  color: #000;
  font-size: 14px;
}

.images-section-cell-large {
  padding: 10px !important;
  vertical-align: top;
  text-align: center;
}

/* 图片包裹容器 */
.images-wrapper {
  overflow: visible;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 维修监督图片网格 - 每行2张 */
.image-grid-supervision {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  width: 100%;
  /* 图片数量不足时居中显示 */
  justify-content: center;
  align-items: center;
}

/* 当只有1-2张图片时，让图片项也居中 */
.image-grid-supervision .image-item-supervision {
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-item-supervision {
  aspect-ratio: 4 / 3;
}

.supervision-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

/* 签字样式 */
.signature-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.signature-image {
  height: 50px;
  width: auto;
  display: block;
  object-fit: contain;
}

/* 打印样式 */
@media print {
  .preview-acceptance-dialog >>> .el-dialog__header,
  .preview-acceptance-dialog >>> .el-dialog__footer {
    display: none;
  }
  
  .preview-content {
    background-color: white;
  }
  
  .acceptance-form,
  .supervision-form {
    width: 210mm;
    min-height: auto;
    padding: 10mm;
    margin: 0;
    box-shadow: none;
    box-sizing: border-box;
  }
  
  .acceptance-table,
  .supervision-table {
    page-break-inside: avoid;
  }
  
  .acceptance-table td,
  .supervision-table td {
    page-break-inside: avoid;
  }
  
  .page-break {
    page-break-after: always;
  }
}

/* 响应式调整 */
@media screen and (max-width: 900px) {
  .acceptance-form {
    width: 100%;
    min-height: auto;
    padding: 10mm;
  }
}

/* 打印时每页分页 */
.page-break {
  page-break-after: always;
}
</style>

